import { useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import AxiosInstance from "../../utils/axiosInstance";

export default function Meeting({
  open,
  handleClose,
  requestApproved,
  page
}) {
  const [categories, setCategories] = useState([
    { label: "Meetings", value: "meeting" , page},
    { label: "Attendances", value: "attendance" ,page },
  ]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [showloader, setloader] = useState(false);



  // Navigate with selected category
  const handleCategorySelect = (selectedValue) => {
    const selectedCategory = categories.find(
      (cat) => cat.value === selectedValue
    );

    if (selectedCategory) {
   
      handleClose();
      navigate("/Reports", { state: { category: selectedCategory } });
    }
  };

  return (
    <Modal size="md" show={open} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Select Report Types </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="d-flex flex-wrap gap-2 justify-content-center">
          {categories.length > 0 ? (
            categories.map((category, index) => (
              <Button
                key={category.value || index}
                variant="outline-primary"
                className="px-4 py-2 text-uppercase"
                onClick={() => handleCategorySelect(category.value)}
              >
                {category.label}
              </Button>
            ))
          ) : (
            <p className="text-center">Loading categories...</p>
          )}
        </div>
      </Modal.Body>
    </Modal>
  );
}
